<template>
	<el-card shadow="never" class="aui-card--fill">
		<el-row style="background-color: #F3F4F4;">
			<el-col :xs="24" :md="6" style="line-height: 40px;font-size: 16px;color: #121212;font-weight: bold;">
				<img style="width: 16px;height: 16px;margin-right: 12px;" src="../../../assets/img/user-list.png" />
				企业开票记录
			</el-col>
			
			<el-col :xs="24" :md="18">
				<el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList();getNum();" style="text-align: right;padding-top: 0 !important;">
					<el-form-item>
						<el-button v-if="$hasPermission('plat:platticketrecord:export')" type="primary" @click="exportHandle()">{{ $t('export') }}</el-button>
					</el-form-item>
					<el-form-item><el-button type="info" @click="getDataList();getNum();">刷新</el-button></el-form-item>
					<el-form-item>
						<el-button v-if="$hasPermission('plat:platticketrecord:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>
					</el-form-item>
				</el-form>
			</el-col>
		</el-row>
		<el-row style="background-color: #f3f4f4">
			<el-col style="line-height: 40px;font-size: 16px;color: #121212;font-weight: bold;background: #fff;">
				<button v-for="(item, index) in options" class="auxiliary-accounting-btn" :class="{ active: item.value == dataForm.ticketStatus }" @click="handleHeadMetaBtn(index)">
				{{`${item.label}(${item.num ? item.num : 0})`}}
				</button>
			</el-col>
		</el-row>
		<div class="mod-plat__platticketrecord">
			<div class="search-form-area">
				<el-form  style="padding:10px 5px 0px;" :label-width="'140px'" :model="dataForm" ref="loginFormRef" @keyup.enter.native="getDataList();getNum()">
					<el-row>
						<el-col :md="12" :lg="6">
							<el-form-item label="开票申请编号:" prop="ticketApplyCode"><el-input style="width: 100%;" v-model="dataForm.ticketApplyCode" placeholder="开票申请编号" clearable></el-input></el-form-item>
						</el-col>
						<el-col :md="12" :lg="6">
							<el-form-item label="购买方企业名称:" prop="buyerName"><el-input style="width: 100%;" v-model="dataForm.buyerName" placeholder="购买方企业名称" clearable></el-input></el-form-item>
						</el-col>
						<el-col :md="12" :lg="6">
							<el-form-item label="统一社会信用编码:" prop="taxCode"><el-input style="width: 100%;" v-model="dataForm.taxCode" placeholder="统一社会信用编码" clearable></el-input></el-form-item>
						</el-col>
						<el-col :md="8" :lg="6" v-if="this.$store.state.user.isSourceOfTax != 1">
							<el-form-item label="税源地:" prop="bodyId">
								<el-select style="width: 100%;" v-model="dataForm.bodyId" placeholder="请选择" clearable filterable>
								<el-option
									v-for="item in bodyPageList"
									:key="item.id"
									:label="`${item.bodyName}-${item.abbreviation}`"
									:value="item.id">
								</el-option>
								</el-select>
							</el-form-item>
						  </el-col>
						
						<el-col :md="12" :lg="9">
							<el-form-item label="申请时间:" prop="applyDate">
								<el-date-picker style="width: 48%;" :picker-options='pickerStartOptions(dataForm.startDate)' v-model="dataForm.applyDate" placeholder="开始时间" format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
								<span style="width:4%;text-align: center;display: inline-block;">~</span>
								<el-date-picker style="width: 48%;" v-model="dataForm.startDate" placeholder="结束时间" :picker-options='pickerEndOptions(dataForm.applyDate)' format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
							</el-form-item>
						</el-col>
						<el-col :md="12" :lg="9">
							<el-form-item label="开票日期:" prop="finishDate">
								<!--<el-input v-model="dataForm.finishDate" placeholder="开票申请编号" clearable></el-input>-->
								<el-date-picker style="width: 48%;" v-model="dataForm.finishDate" :picker-options='pickerStartOptions(dataForm.endDate)' placeholder="开始日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
								<span style="width:4%;text-align: center;display: inline-block;">~</span>
								<el-date-picker style="width: 48%;" v-model="dataForm.endDate" :picker-options='pickerEndOptions(dataForm.finishDate)' placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
							</el-form-item>
						</el-col>
						<!-- <el-col :md="12" :lg="6">
							<el-form-item label="开票状态:" prop="ticketStatus">
								<el-select style="width: 100%;" v-model="dataForm.ticketStatus" placeholder="开票状态" clearable filterable>
									<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" :disabled="item.disabled"></el-option>
								</el-select>
							</el-form-item>
						</el-col> -->
						<el-col :md="24" :lg="6">
							<el-form-item label-width="0px">
								<div style="text-align: right;">
									<el-button type="primary" @click="getDataList();getNum()">{{ $t('query') }}</el-button>
									<el-button type="info" @click="resetLoginForm">重置</el-button>
								</div>

							</el-form-item>
						</el-col>
					</el-row>
				</el-form>
			</div>
			<div class="table-container">
				<el-table v-loading="dataListLoading" :data="dataList" @selection-change="dataListSelectionChangeHandle" style="width: 100%;" :show-summary="true" :summary-method="getSummaries" height="100%">
					<el-table-column type="selection" header-align="center" align="center" width="50" class-name="selection"></el-table-column>
					<el-table-column label="序号" type="index" width="50" align="center">
						<template slot-scope="scope">
							<span>{{ (page - 1) * limit + scope.$index + 1 }}</span>
						</template>
					</el-table-column>
					<el-table-column prop="ticketApplyCode" label="开票申请编号" header-align="center" align="center"></el-table-column>
					<!-- <el-table-column prop="ticketApplyCode" label="开票申请编号" header-align="center" align="center">
						<template slot-scope="scope">
							<el-button type="text" class="el_hover_dectrion" size="small" @click="goTaskInfo(scope.row.taskId)">{{scope.row.taskCode}}</el-button>
						</template>
					</el-table-column> -->
					<el-table-column prop="abbreviation" label="税源地简称" header-align="center" align="center"></el-table-column>
					<el-table-column prop="taskCode" label="任务编号" header-align="center" align="center">
						<template slot-scope="scope">
							<el-button type="text" class="el_hover_dectrion" size="small" @click="goTaskInfo(scope.row.taskId)">{{scope.row.taskCode}}</el-button>
						</template>
					</el-table-column>
					<el-table-column prop="taskTypeName" label="任务大类" header-align="center" align="center">
						<template slot-scope="scope">
							<span>{{scope.row.taskTypeName}}</span>
						</template>
					</el-table-column>
					<el-table-column prop="buyerName" label="购买方企业名称" header-align="center" align="center"></el-table-column>
					<el-table-column prop="buyerTaxCode" label="购买方的信用代码" header-align="center" align="center"></el-table-column>
					<el-table-column prop="ticketType" label="发票类型" header-align="center" align="center"></el-table-column>
					<el-table-column prop="money" label="含税金额(元)" header-align="center" align="center"></el-table-column>
					<el-table-column prop="ticketStatus" label="开票状态" header-align="center" align="center">
						<template slot-scope="scope">
							<el-tag v-if="scope.row.ticketStatus == 0 || scope.row.ticketStatus == 1" size="small" type="info">待审核</el-tag>
							<el-tag v-else-if="scope.row.ticketStatus == 2" size="small" type="warning">待开票</el-tag>
							<!-- <el-tag v-else-if="scope.row.ticketStatus == 1" size="small" type="warning">待审核</el-tag> -->
							<!-- <el-tag v-else-if="scope.row.ticketStatus == 2" size="small" type="success">待开票</el-tag> -->
							<el-tag v-else size="small" type="danger">已开票</el-tag>
						</template>
					</el-table-column>
					<!-- <el-table-column prop="invoiceCode" v-if="role == 'OPERATE'" label="发票代码" header-align="center" align="center"></el-table-column> -->
					<el-table-column prop="invoiceNum" v-if="role == 'OPERATE'" label="发票号码" header-align="center" align="center"></el-table-column>
					<el-table-column prop="invoiceItem" v-if="role == 'OPERATE'" label="开票项目" header-align="center" align="center"></el-table-column>
					
					<el-table-column prop="bodyName" label="开票主体名称" header-align="center" align="center"></el-table-column>
					<!-- <el-table-column prop="expressCode" label="开票单号" header-align="center" align="center"></el-table-column>-->
					<el-table-column prop="applyDate" label="申请时间" header-align="center" align="center"></el-table-column>
					<el-table-column prop="finishDate" label="开票日期" header-align="center" align="center"></el-table-column>

					<el-table-column :label="$t('handle')"  header-align="center" align="center" width="150">
					  <template slot-scope="scope">
						<el-button type="text" size="small" @click="childHandle(scope.row.dealApprovalIds)">查看详情</el-button>
						<!-- <el-button type="text" size="small" @click="downHandle(scope.row)">下载发票申请单</el-button> -->
					  </template>
					</el-table-column>
				</el-table>
				<el-pagination
					background
					:current-page="page"
					:page-sizes="[10, 20, 50, 100]"
					:page-size="limit"
					:total="total"
					layout="total, sizes, prev, pager, next, jumper"
					@size-change="pageSizeChangeHandle"
					@current-change="pageCurrentChangeHandle"
				></el-pagination>
			</div>
			<!-- 弹窗, 新增 / 修改 -->
			<add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
		</div>
	</el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './platticketrecord-add-or-update'
import { addDynamicRoute } from '@/router'
import Cookies from 'js-cookie'
import ArrayUtils from "../../../utils/ArrayUtils";

export default {
  mixins: [mixinViewModule],
  data () {
    return {
		pickerStartOptions(endTime){
                return {
                    disabledDate(time){
                        if(endTime){
                        // 拼接 00:00:00 是为了统一日期从0点开始 
                        return time.getTime() > new Date(endTime +' 00:00:00').getTime();
                        }
                    }
                } 
            },
            pickerEndOptions(startTime){
                return {
                    disabledDate(time){
                        if(startTime){
                        // 拼接 00:00:00 是为了统一日期从0点开始 
                        return time.getTime() < new Date(startTime +' 00:00:00').getTime();
                        }
                    }
                }
            },
		countNum:0,
		taskList:[],
		role: Cookies.get("admin_role"),
      options: [

        // {
        //   value: '0',
        //   label: '草稿'
        // },
        // {
        //   value: '1',
        //   label: '待审核'
        // },
		{
          value: '0,1,2',
          label: '待开票'
        },
        {
          value: '3',
          label: '已开票'
        }
      ],
      value: '',
      role: Cookies.get('admin_role'),
      mixinViewModuleOptions: {
		createdIsNeed:false,
        getDataListURL: '/sys/plat/platticketrecord/page',
        getDataListIsPage: true,
        deleteURL: '/sys/plat/platticketrecord',
        deleteIsBatch: true,
        exportURL: '/sys/plat/platticketrecord/export',
		isBodyPage:true

      },
      dataForm: {
        id: '',
        ticketApplyCode: '',
		bodyId:'',
        buyerName: '',
        taxCode: '',
        startDate: '',
        ticketStatus: '0,1,2',
        status: '',
        endDate: '',
        finishDate: '',
        applyDate: ''
      }
    }
  },
  components: {
    AddOrUpdate
  },
  created(){
	this.$set(this.dataForm,'ticketStatus',localStorage.getItem('platticke-activeIndex') || '0,1,2')
	//   this.dataForm.ticketStatus = localStorage.getItem('platticke-activeIndex') || '0,1,2'
	  this.$nextTick(() => {
		// this.getDropDownData();
		if(this.$store.state.user.isSourceOfTax == 1){
			this.dataForm.bodyId = this.$store.state.user.bodyIds
		}
		this.getDataList();
		this.getNum();
	  })
	  
  },
  methods: {
	handleHeadMetaBtn(ind) {
      // this.getNum();
      localStorage.setItem('platticke-activeIndex',this.options[ind].value)
	  this.dataForm.ticketStatus = this.options[ind].value;
      this.$nextTick(() => {
        this.getDataList();
		this.getNum();
      })
    },
	// 统计数量
	getNum(){
		this.$http.get('/sys/plat/platticketrecord/countTicketRecord',{}).then(({data:res}) => {
			if(res.code == 0){
				// this.$set(this.options[0],'num',res.data.pendingApplication);
				// this.$set(this.options[1],'num',res.data.pendingApproval);
				this.$set(this.options[0],'num',res.data.pendingInvoicing);
				this.$set(this.options[1],'num',res.data.invoiced);
			}
		})
		this.$http.get("sys/plat/platticketrecord/count",{
			params:this.dataForm
		}).then(({ data:res1 }) => {
			this.countNum = res1.data
		})
	},
	// 统计金额
	getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        if (index === 9) { //指定哪一列合计 如果需要全部合计 去掉这个判断即可
        //   const values = data.map((item) => Number(item[column.property]));
        //   if (!values.every((value) => isNaN(value))) {
        //     sums[index] = values.reduce((prev, curr) => {
        //       const value = Number(curr);
		// 	  console.log(isNaN(value))
        //       if (!isNaN(value)) {
        //         return (Number(prev)+Number(curr)).toFixed(2);
        //       } else {
        //         return Number(prev).toFixed(2);
        //       }
        //     }, 0);
        //   } else {
        //     sums[index] = "";
        //   }
			sums[9] = Number(this.countNum).toFixed(2)
        }
      });
      return sums;
    },
	  //任务发布编号
            goTaskInfo(id){
			localStorage.setItem(this.$route.name,JSON.stringify(this.dataForm))
                // 路由参数
                const routeParams = {
                    routeName: `${this.$route.name}__任务详情`,
                    title: `任务详情`,
                    path: 'plat/platttask-info',
                    params: {
                        id:id
                    }
                }
				// localStorage.setItem('qykpRwId',id);
                // 动态路由
                addDynamicRoute(routeParams, this.$router)
            },
	  handleTaskType(type){
		  return  ArrayUtils.getItemBy(
            this.taskList,
            "dictValue",
            type
          ).dictLabel
	  },
	  //            任务大类请求
    getDropDownData() {
      this.$http
        .get(
          "sys/dict/data/page?page=1&limit=1000&dictTypeId=1289513229072973825"
        )
        .then(({ data: res }) => {
          if (res.code == 0) {
            this.taskList = res.data.list;
          } else {
            this.$message.error(res.msg);
          }
        });
    },
    // 点击重置按钮，重置登陆表单
    // 1.在表单中引入ref="loginFormRef"属性，loginFormRef值可以自定义；
    // 2.给重置按钮绑定点击事件：@click="resetLoginForm"；
    // 3.实现点击事件触发的方法，得到引入的属性值对象，调用resetFields方法，即：this.$refs.loginFormRef.resetFields()
    resetLoginForm () {
      this.$refs.loginFormRef.resetFields()
      this.dataForm.startDate = ''
      this.dataForm.bodyId = ''
	  if(this.$store.state.user.isSourceOfTax == 1){
			this.dataForm.bodyId = this.$store.state.user.bodyIds
		}
      this.dataForm.endDate = ''

      this.getDataList()
	  this.getNum()
    },
    childHandle (id) {
			localStorage.setItem(this.$route.name,JSON.stringify(this.dataForm))
		  // 路由参数
		  const routeParams = {
			routeName: `${this.$route.name}__申请发票`,
			title: `申请发票`,
			path: 'plat/platinvoicingtasklist-add',
			params: {
			id: id.split(',')
			}
		  }
		  // 动态路由
		  addDynamicRoute(routeParams, this.$router)
    },
	// 下载发票申请单
	downHandle(row){
		window.open(`${window.SITE_CONFIG['apiURL']}/sys/plat/platticketrecord/downloadInvoiceInfo?recordId=${row.id}&access_token=${Cookies.get('access_token')}`)
	}
  }
}
</script>
<style scoped lang="scss">
/* .el-table {
  display: flex;
  flex-direction: column;
} */
/deep/ .el-table__body-wrapper{
	order:1 !important;
}

.auxiliary-accounting-btn {
	cursor: pointer;
  // width: 98px;
  height: 30px;
  border: 0px;
  padding:0 10px;
  background: 0;
  &.active {
    background: white;
    height: 30px;
    color: blue;
    border-bottom: 3px solid blue;
  }
  &:first-child {
    border-left: 1px solid #e6e6e6;
  }
}

.mod-plat__platticketrecord {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 230px);

  .search-form-area {
    flex-shrink: 0;
  }

  .table-container {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    .el-table {
      flex: 1;
      overflow: hidden;
    }

    .el-pagination {
      flex-shrink: 0;
      margin-top: 20px;
      text-align: right;
    }
  }
}

/deep/ .el-table {
  .el-table__header-wrapper {
    position: sticky;
    top: 0;
    z-index: 10;
    background-color: #f5f7fa;
  }

  .el-table__fixed-header-wrapper {
    position: sticky;
    top: 0;
    z-index: 10;
    background-color: #f5f7fa;
  }

  .el-table__footer-wrapper {
    position: sticky;
    bottom: 0;
    z-index: 10;
    background-color: #f5f7fa;
  }

  .el-table__fixed-footer-wrapper {
    position: sticky;
    bottom: 0;
    z-index: 10;
    background-color: #f5f7fa;
  }
}
// .selection .cell{
// 	padding: 0 !important;
// }
</style>